/* eslint-disable import/prefer-default-export */
import React from 'react'
import { SvgIconProps } from './SvgIconProps'

export const NewTab: React.FC<SvgIconProps> = ({
  size = '24px',
  color = 'currentColor',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.375 4C14.375 3.65482 14.6548 3.375 15 3.375H20C20.3452 3.375 20.625 3.65482 20.625 4V9C20.625 9.34518 20.3452 9.625 20 9.625C19.6548 9.625 19.375 9.34518 19.375 9V5.50888L10.4419 14.4419C10.1979 14.686 9.80214 14.686 9.55806 14.4419C9.31398 14.1979 9.31398 13.8021 9.55806 13.5581L18.4911 4.625H15C14.6548 4.625 14.375 4.34518 14.375 4ZM4.14384 7.14384C4.63613 6.65156 5.30381 6.375 6 6.375H11C11.3452 6.375 11.625 6.65482 11.625 7C11.625 7.34518 11.3452 7.625 11 7.625H6C5.63533 7.625 5.28559 7.76987 5.02773 8.02773C4.76987 8.28559 4.625 8.63533 4.625 9V18C4.625 18.3647 4.76987 18.7144 5.02773 18.9723C5.28559 19.2301 5.63533 19.375 6 19.375H15C15.3647 19.375 15.7144 19.2301 15.9723 18.9723C16.2301 18.7144 16.375 18.3647 16.375 18V13C16.375 12.6548 16.6548 12.375 17 12.375C17.3452 12.375 17.625 12.6548 17.625 13V18C17.625 18.6962 17.3484 19.3639 16.8562 19.8562C16.3639 20.3484 15.6962 20.625 15 20.625H6C5.30381 20.625 4.63613 20.3484 4.14384 19.8562C3.65156 19.3639 3.375 18.6962 3.375 18V9C3.375 8.30381 3.65156 7.63613 4.14384 7.14384Z"
        fill={color}
      />
    </svg>
  )
}
